<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="layout--main" :class="[navbarClasses, footerClasses, { 'app-page': isAppPage }]">
    <vx-tour :steps="steps" v-if="!disableThemeTour" />

    <the-customizer @updateNavbar="updateNavbar" @updateNavbarColor="updateNavbarColor" :navbarType="navbarType"
                    :navbarColor="navbarColor" :footerType="footerType" @updateFooter="updateFooter"
                    :routerTransition="routerTransition" @updateRouterTransition="updateRouterTransition" v-if="true"
                    :hideScrollToTop="hideScrollToTop" @toggleHideScrollToTop="toggleHideScrollToTop" />

    <vx-sidebar v-if="!$route.meta.hideSidebar" :sidebarItems="sidebarItemsDynamic" :logo="getLogo()"
                :title="getAccountShortName()" parent=".layout--main" />

    <div id="content-area" :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]">
      <div id="content-overlay"></div>

      <div class="content-wrapper">
        <the-navbar v-if="!$route.meta.hideNavbar" :navbarColor="navbarColor" :class="[
          { 'text-white': isNavbarDark && !isThemeDark },
          { 'text-base': !isNavbarDark && isThemeDark },
        ]" />
        <div class="router-view"
             :style="(this.$route.query.inEmbed && this.$route.query.inEmbed == 'true') ? 'padding: 0px !important' : ''">
          <div class="router-content" :class="{
            'mt-0': navbarType == 'hidden' || $route.meta.hideNavbar,
          }">
            <transition :name="routerTransition">
              <div class="router-header flex flex-wrap items-center mb-6" v-if="($route.meta.breadcrumb || $route.meta.pageTitle) &&
                !isVisualStudio &&
                !$route.meta.hideBreadcrumb
                ">
                <div class="content-area__heading" :class="{
                  'pr-4 border-0 md:border-r border-t-0 border-b-0 border-l-0 border-solid border-grey-light':
                    $route.meta.breadcrumb,
                }">
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb class="ml-4 md:block hidden"
                               v-if="$route.meta.breadcrumb && !$route.meta.hideBreadcrumb" />

                <!-- DROPDOWN -->
                <vs-dropdown class="ml-auto md:block hidden cursor-pointer" vs-trigger-click>
                  <vs-button radius icon="icon-settings" v-if="false" icon-pack="feather"></vs-button>

                  <vs-dropdown-menu class="w-32">
                    <vs-dropdown-item>
                      <div @click="$router.push('/pages/profile')" class="flex items-center">
                        <feather-icon icon="UserIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                        <span>Profile</span>
                      </div>
                    </vs-dropdown-item>

                    <vs-dropdown-item>
                      <div @click="$router.push('/apps/todo')" class="flex items-center">
                        <feather-icon icon="CheckSquareIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                        <span>Tasks</span>
                      </div>
                    </vs-dropdown-item>

                    <vs-dropdown-item>
                      <div @click="$router.push('/apps/email')" class="flex items-center">
                        <feather-icon icon="MailIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                        <span>Inbox</span>
                      </div>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </transition>
            <div class="content-area__content">
              <back-to-top bottom="5%" visibleoffset="500" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg" />
              </back-to-top>
              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle"></router-view>
              </transition>
            </div>
          </div>
        </div>
      </div>

      <the-footer></the-footer>
    </div>
  </div>
</template>

<script>
  import VxSidebar from "@/layouts/components/vx-sidebar/VxSidebar.vue";
  import TheCustomizer from "../components/customizer/TheCustomizer.vue";
  import TheNavbar from "../components/TheNavbar.vue";
  import TheFooter from "../components/TheFooter.vue";
  import themeConfig from "@/../themeConfig.js";
  import SidebarMenu from "@/layouts/components/vx-sidebar/sidebarItems.js";
  import BackToTop from "vue-backtotop";
  const VxTour = () => import("@/components/VxTour.vue");
  import TCVelikClient from "@/TCVelikClient/TCVelikClient.js";

  export default {
    data() {
      return {
        navbarType: themeConfig.navbarType || "floating",
        navbarColor: this.isVisualStudio
          ? "transparent"
          : themeConfig.navbarColor || "#fff",
        footerType: themeConfig.footerType || "static",
        routerTransition: themeConfig.routerTransition || "none",
        isNavbarDark: true,
        routeTitle: this.$route.meta.pageTitle,
        sidebarItemsDynamic: [],
        disableCustomizer: false,
        windowWidth: window.innerWidth, //width of windows
        hideScrollToTop: themeConfig.hideScrollToTop,
        disableThemeTour: themeConfig.disableThemeTour,
        steps: [
          {
            target: ".logo",
            content: "Welcome to TCVelik!<br/><small>We'll take you on a very brief tour!</small>",
          },
          {
            target: "#btnSidebarToggler",
            content: "This is your navigation",
          },
          {
            target: "#ContextAndOnboarding",
            content: "My Alignment<p class='tour-text'>This page helps you align with your team. It contains all onboarding and alignment materials, assessments and statistics for all your initiatives.</p>",
            navigateTo: "/pages/context-and-onboarding"
          },
          {
            target: ".user-profile-main",
            content: "Your profile settings are located here.",
          },
          {
            target: ".accounts-wrapper",
            content:
              "If you have access to multiple accounts - they will be lister here.",
          },
        ],
      };
    },
    watch: {
      $route() {
        this.routeTitle = this.$route.meta.pageTitle;
      },
      isThemeDark(val) {
        if (this.navbarColor == "#fff" && val) {
          this.updateNavbarColor("#10163a");
        } else {
          this.updateNavbarColor("#fff");
        }
      },
    },
    computed: {
      isAppPage() {
        if (this.$route.path.includes("/apps/")) return true;
        else return false;
      },
      isThemeDark() {
        return this.$store.state.theme == "dark";
      },
      sidebarWidth() {
        if (this.$route.meta.hideSidebar)
          return "content-area-full";
        return this.$route.meta.sidebarWidth || this.$store.state.sidebarWidth;
      },
      bodyOverlay() {
        return this.$store.state.bodyOverlay;
      },
      contentAreaClass() {
        if (this.sidebarWidth == "default") return "content-area-default";
        else if (this.sidebarWidth == "reduced") return "content-area-reduced";
        else if (this.sidebarWidth || this.$route.meta.hideSidebar) return "content-area-full";
      },
      navbarClasses() {
        return {
          "navbar-hidden": this.navbarType == "hidden",
          "navbar-sticky": this.navbarType == "sticky" || this.isVisualStudio,
          "navbar-static": this.navbarType == "static",
          "navbar-floating": this.navbarType == "floating",
        };
      },
      footerClasses() {
        return {
          "footer-hidden": this.footerType == "hidden" || this.isVisualStudio,
          "footer-sticky": this.footerType == "sticky",
          "footer-static": this.footerType == "static",
        };
      },
      isVisualStudio() {
        return this.$store.state.IsVisualStudio;
      },
    },
    methods: {
      changeRouteTitle(title) {
        this.routeTitle = title;
      },
      updateNavbar(val) {
        if (val == "static") this.updateNavbarColor("#fff");
        this.navbarType = val;
      },
      updateNavbarColor(val) {
        this.navbarColor = val;
        if (val == "#fff") this.isNavbarDark = false;
        else this.isNavbarDark = true;
      },
      updateFooter(val) {
        this.footerType = val;
      },
      updateRouterTransition(val) {
        this.routerTransition = val;
      },
      handleWindowResize(event) {
        this.windowWidth = event.currentTarget.innerWidth;
        this.setSidebarWidth();
      },
      setSidebarWidth() {
        if (this.$route.meta.collapseSidebar) {
          this.$store.dispatch("updateSidebarWidth", "reduced");
        } else if (this.windowWidth < 1200) {
          this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", false);
          this.$store.dispatch("updateSidebarWidth", "no-sidebar");
          this.disableThemeTour = themeConfig.disableThemeTour;
        } else if (this.windowWidth < 1200) {
          this.$store.dispatch("updateSidebarWidth", "reduced");
        } else {
          this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
        }
      },
      toggleHideScrollToTop(val) {
        this.hideScrollToTop = val;
      },
      getLogo() {

        // return "/favicon.ico";

        var account = TCVelikClient.getSelectedAccount();
        if (account && account.AccountBranding && account.AccountBranding.MainLogoUrl) {
          return account.AccountBranding.MainLogoUrl;
        }
      },
      getAccountShortName() {
        return "TCVelik";
        var account = TCVelikClient.getSelectedAccount();
        if (account && account.AccountBranding && account.AccountBranding.CompanyName) {
          return account.AccountBranding.CompanyName;
        }
      }
    },
    components: {
      VxSidebar,
      TheNavbar,
      TheFooter,
      TheCustomizer,
      BackToTop,
      VxTour,
    },
    async created() {
      this.setSidebarWidth();
      if (this.navbarColor == "#fff" && this.isThemeDark) {
        this.updateNavbarColor("#10163a");
      } else {
        this.updateNavbarColor(this.navbarColor);
      }

      this.sidebarItemsDynamic = await SidebarMenu.fillMenu();
      this.sidebarItemsDynamic = await SidebarMenu.fillAnalytics();
    },
  };
</script>
<style>
  .tour-text {
    font-size: 0.75em;
  }
</style>
